import { render, staticRenderFns } from "./AccountPerformanceForm.vue?vue&type=template&id=071b8794&scoped=true"
import script from "./AccountPerformanceForm.vue?vue&type=script&lang=ts"
export * from "./AccountPerformanceForm.vue?vue&type=script&lang=ts"
import style0 from "./AccountPerformanceForm.vue?vue&type=style&index=0&id=071b8794&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071b8794",
  null
  
)

export default component.exports